export const ApprovalActorRole = {
  REQUESTER: 'REQUESTER',
  APPROVER: 'APPROVER',
  NON_PARTICIPANT: 'NON_PARTICIPANT'
};